(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/actions/player-competition-actions.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/actions/player-competition-actions.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk,
  createAction = _RTK.createAction;
const FetchState = svs.components.marketplaceCompetition.constants.FetchState;
const _svs$components$marke = svs.components.marketplaceCompetition.services.selectors.playerCompetitionSelectors,
  selectPlayerCompetition = _svs$components$marke.selectPlayerCompetition,
  selectPlayerCompetitionsStatus = _svs$components$marke.selectPlayerCompetitionsStatus;
const userSession = svs.core.userSession;
const competitionHandler = svs.components.marketplaceCompetition.competitionHandler.competitionHandler;
const services = svs.components.marketplaceCompetition.services.services;
const COMPETITION_CACHE_TTL_IN_MINUTES = 5;
const getElapsedMinutes = date => {
  const _date = new Date(date);
  if (!dateFns.isValid(_date)) {
    return Number.POSITIVE_INFINITY;
  }
  return dateFns.differenceInMinutes(new Date(), _date);
};
const fetchPlayerCompetitionCondition = (arg, _ref) => {
  let getState = _ref.getState;
  const hasPlayer = userSession.hasRole(userSession.roles.PLAYER);
  if (!hasPlayer || userSession.isAnonymous()) {
    return false;
  }
  const state = getState();
  const _ref2 = arg || {},
    competitionId = _ref2.competitionId,
    _ref2$forceFetch = _ref2.forceFetch,
    forceFetch = _ref2$forceFetch === void 0 ? false : _ref2$forceFetch;
  const playerCompetition = competitionId ? selectPlayerCompetition(state, competitionId) : null;
  const _selectPlayerCompetit = selectPlayerCompetitionsStatus(state),
    _selectPlayerCompetit2 = _slicedToArray(_selectPlayerCompetit, 2),
    status = _selectPlayerCompetit2[0],
    lastFetched = _selectPlayerCompetit2[1];
  const minutesSinceLastFetched = getElapsedMinutes(lastFetched);
  const isLoading = status === FetchState.Pending;
  const isRejected = status === FetchState.Rejected;
  const isRecentlyFetched = minutesSinceLastFetched < COMPETITION_CACHE_TTL_IN_MINUTES;
  if (isLoading || isRejected && !forceFetch) {
    return false;
  }
  if (isRecentlyFetched && (!competitionId || playerCompetition)) {
    return false;
  }
};
const fetchPlayerCompetitions = createAsyncThunk('fetchPlayerCompetitions', async options => {
  const _ref3 = options || {},
    _ref3$isActiveOnly = _ref3.isActiveOnly,
    isActiveOnly = _ref3$isActiveOnly === void 0 ? true : _ref3$isActiveOnly;
  const _await$competitionHan = await competitionHandler().fetchPlayerCompetitions(isActiveOnly),
    _await$competitionHan2 = _slicedToArray(_await$competitionHan, 1),
    result = _await$competitionHan2[0];
  return result;
}, {
  condition: fetchPlayerCompetitionCondition
});
const fetchPlayerCompetitionDrawStatusCondition = (competitionId, _ref4) => {
  var _state$Competition$Pl, _state$Competition$Pl2;
  let getState = _ref4.getState;
  const hasPlayer = userSession.hasRole(userSession.roles.PLAYER);
  if (!hasPlayer) {
    return false;
  }
  const state = getState();
  const lastFetched = new Date((_state$Competition$Pl = state.Competition.PlayerCompetitions.draws[competitionId]) === null || _state$Competition$Pl === void 0 ? void 0 : _state$Competition$Pl.lastFetch);
  const status = (_state$Competition$Pl2 = state.Competition.PlayerCompetitions.draws[competitionId]) === null || _state$Competition$Pl2 === void 0 ? void 0 : _state$Competition$Pl2.status;
  const minutesSinceLastFetched = getElapsedMinutes(lastFetched);
  const isRecentlyFetched = minutesSinceLastFetched < COMPETITION_CACHE_TTL_IN_MINUTES;
  const isLoading = status !== null && status !== void 0 ? status : FetchState.Idle === FetchState.Pending;
  if (isLoading || isRecentlyFetched) {
    return false;
  }
};
const fetchPlayerCompetitionDrawStatus = createAsyncThunk('fetchPlayerCompetitionDrawStatus', competitionId => competitionHandler().fetchPlayerCompetitionDraws([competitionId]), {
  condition: fetchPlayerCompetitionDrawStatusCondition
});
const setPlayerCompetitionDraw = createAction('setPlayerCompetitionDraw', _ref5 => {
  let drawNumber = _ref5.drawNumber,
    competitionId = _ref5.competitionId;
  return {
    payload: {
      drawNumber,
      competitionId
    }
  };
});
const deletePlayerCompetitionDraw = createAction('deletePlayerCompetitionDraw', _ref6 => {
  let drawNumber = _ref6.drawNumber,
    competitionId = _ref6.competitionId;
  return {
    payload: {
      drawNumber,
      competitionId
    }
  };
});
const setPlayerCompetitionSignedUp = createAction('setPlayerCompetitionSignedUp', _ref7 => {
  let competitionId = _ref7.competitionId;
  return {
    payload: {
      competitionId
    }
  };
});
const putParticipation = createAsyncThunk('putParticipation', _ref8 => {
  let competitionId = _ref8.competitionId;
  return services.putParticipation(competitionId);
});
setGlobal('svs.components.marketplaceCompetition.services.actions.playerCompetitionActions', {
  deletePlayerCompetitionDraw,
  fetchPlayerCompetitions,
  fetchPlayerCompetitionDrawStatus,
  setPlayerCompetitionDraw,
  setPlayerCompetitionSignedUp,
  putParticipation
});

 })(window);